import React, { Component } from 'react'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import CKEditor from '@ckeditor/ckeditor5-react'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'


export class RichTextEditor extends Component {
  render() {
    const { tagsProtocol, placeholder, tagProtocol } = this.props
    const fromTags = ['italic', '|', "numberedList", "bulletedList", '|', 'link', '|', 'heading']
    const fromCreate = ['heading', '|', 'bold', 'italic', '|', "numberedList", "bulletedList", '|', 'link', 'Insert image', 'Insert media', '|', 'undo', 'redo']

    return (
      <div>
        <CKEditor
          editor={ClassicEditor}
          data={tagsProtocol ? tagProtocol : ""}
          onChange={(event, editor) => {
            const data = editor.getData();
            this.props.onType(data)
          }}
          config={{
            removePlugins: tagsProtocol ? ['Insert image', 'Insert media'] : [],
            toolbar: tagsProtocol ? fromTags : fromCreate,
            placeholder
          }}
        />
      </div>
    )
  }
}

const mapStateToProps = () => {
  return {}
}

export default injectIntl(connect(mapStateToProps, {})(RichTextEditor))
